import { t } from "i18next"
import { Flex, Group, Skeleton, Title } from "components/common"

const ClientProfileFormSkeleton = () => {
  const radioRow = (count = 4) => (
    <Flex gap="16px" wrap="wrap" className="mbe-20" style={{ alignItems: "center" }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={{ flexShrink: 0 }}>
          <Skeleton type="radioButton" width={80} height={32} active />
        </div>
      ))}
    </Flex>
  )
  const inputRow = (count = 2) => (
    <Group template="repeat(2, 1fr)" gap="24px 64px" className="mbe-32">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={{ minWidth: 0 }} className="mbe-24">
          <div className="mbe-16">
            <Skeleton type="label" active />
          </div>
          <Skeleton type="input" active />
        </div>
      ))}
    </Group>
  )
  const sectionTitle = () => (
    <Skeleton type="antTitle" titleHeight="20px" titleWidth="220px" className="mbe-20" active />
  )

  return (
    <>
      <div className="mbe-32">
        <Title level={3}>{t("Client Profile")}</Title>
        <Flex gap="24px" className="mbe-0" style={{ flexWrap: "wrap", alignItems: "center" }}>
          <div style={{ flexShrink: 0 }}>
            <Skeleton type="input" height={20} width={140} active />
          </div>
          <div style={{ flexShrink: 0 }}>
            <Skeleton type="input" height={20} width={160} active />
          </div>
        </Flex>
      </div>

      <div className="mbe-32">
        {sectionTitle()}
        {radioRow(4)}
        {inputRow(2)}
      </div>

      <div className="mbe-32">
        {sectionTitle()}
        {inputRow(2)}
        <div className="mbe-32">
          <div className="mbe-16">
            <Skeleton type="label" active />
          </div>
          <Skeleton type="input" height={24} style={{ maxWidth: 380 }} active />
        </div>
      </div>

      <div className="mbe-32">
        {sectionTitle()}
        {radioRow(3)}
        {inputRow(2)}
      </div>

      <div className="mbe-32">
        {sectionTitle()}
        {inputRow(2)}
      </div>
    </>
  )
}

export default ClientProfileFormSkeleton
